import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/categories', label: '话题分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-compass-3-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold" style={{ color: isScrolled ? 'oklch(var(--foreground-900))' : '#fff' }}>
              海角社区
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  location.pathname === link.to
                    ? isScrolled ? 'text-primary-600' : 'text-accent-400'
                    : isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium rounded-full border cursor-pointer whitespace-nowrap transition-all duration-200"
              style={{
                borderColor: isScrolled ? 'oklch(var(--primary-300))' : 'rgba(255,255,255,0.4)',
                color: isScrolled ? 'oklch(var(--primary-600))' : '#fff',
              }}
            >
              加入我们
            </Link>
            <Link
              to="/categories"
              className="px-5 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
            >
              开始探索
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i
              className={`text-xl ${isScrolled ? 'text-foreground-900' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 px-3 rounded-lg whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-2">
              <Link
                to="/about"
                className="flex-1 text-center py-2 text-sm font-medium rounded-full border border-primary-300 text-primary-600 cursor-pointer whitespace-nowrap"
              >
                加入我们
              </Link>
              <Link
                to="/categories"
                className="flex-1 text-center py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 cursor-pointer whitespace-nowrap"
              >
                开始探索
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}